import { CreateSaleTypes } from './types';

export const createSales = (plan: object) => {
  return {
    types: [
      CreateSaleTypes.GET_CREATE_SALE_REQUEST,
      CreateSaleTypes.GET_CREATE_SALE_SUCCESS,
      CreateSaleTypes.GET_CREATE_SALE_FAILURE,
    ],
    plan,
    promise: (client: any) => client.post(`/api/controle_crm/sales_front`, { plan }),
  };
};
